import React, { useEffect, useState } from "react";
import Corner from "./../corner1";
import { MdAccessTimeFilled } from "react-icons/md";
import { TiTick } from "react-icons/ti";
import { FaProjectDiagram } from "react-icons/fa";

const CenteredBoxComponent = () => {
  const [animate, setAnimate] = useState(false);
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);

  useEffect(() => {
    const handleScroll = () => {
      const element = document.querySelector(".container");
      if (element) {
        const rect = element.getBoundingClientRect();
        if (rect.top < window.innerHeight * 0.5) {
          setAnimate(true);
        }
      }
    };

    const handleResize = () => setWindowWidth(window.innerWidth);

    window.addEventListener("scroll", handleScroll);
    window.addEventListener("resize", handleResize);
    handleScroll();
    return () => {
      window.removeEventListener("scroll", handleScroll);
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  // Responsive styles dynamically calculated based on screen width
  const getResponsiveStyles = () => {
    if (windowWidth <= 480) {
      return {
        centeredBoxWidth: "90%",
        imageHeight: "400px",
        verticalLineHeight: "200px",
        padding: "10px",
        flexDirection: "column",
        textAlign: "center",
        imageColumnPadding: "0",
        cornerSize: "40px",
      };
    } else if (windowWidth <= 768) {
      return {
        centeredBoxWidth: "75%",
        imageHeight: "400px",
        verticalLineHeight: "150px",
        padding: "20px",
        flexDirection: "row",
        textAlign: "left",
        imageColumnPadding: "50px",
        cornerSize: "50px",
      };
    }
    return {
      centeredBoxWidth: "40%",
      imageHeight: "500px",
      verticalLineHeight: "200px",
      padding: "30px",
      flexDirection: "row",
      textAlign: "left",
      imageColumnPadding: "150px",
      cornerSize: "60px",
    };
  };

  const styles = getResponsiveStyles();

  return (
    <div>
      <div className={`container ${animate ? "slide-in" : ""}`} style={{ width: "100%", position: "relative" ,marginTop:"100px"}}>
        {/* Background Image */}
        <div style={{ width: "100%", height: styles.imageHeight }}>
          <img
            src="https://img.freepik.com/free-photo/scandinavian-living-room-interior-design-zoom-background_53876-143147.jpg"
            alt="Background"
            style={{ width: "100%", height: "100%", objectFit: "cover" }}
          />
        </div>

        {/* Centered Info Box */}
        <div
          style={{
            position: "absolute",
            top: "27%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            background: "white",
            padding: styles.padding,
            boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.1)",
            textAlign: "center",
            zIndex: 10,
            width: styles.centeredBoxWidth,
            transition: "all 0.3s ease-in-out",
          }}
        >
          <h2 style={{ fontWeight: "bold", color: "#5c0e14" }}>Project Management</h2>
          <h3>Delivering Excellence, On Time</h3>
          <p>
            Effective project management is at the heart of every successful build. Our team oversees every phase of the project, ensuring on-time delivery, 
            quality control, and cost efficiency.
          </p>
        </div>

        {/* Vertical Line (Responsive) */}
        <div
          style={{
            position: "absolute",
            top: "-5%",
            left: "50%",
            transform: "translateX(-50%)",
            width: "2px",
            height: styles.verticalLineHeight,
            background: "#5c0e14",
            zIndex: 20,
          }}
        ></div>

        {/* Two Columns Below the Image */}
        <div style={{ display: "flex", flexWrap: "wrap", flexDirection: styles.flexDirection, marginTop: "50px", padding: styles.padding }}>
          {/* First Column - Added Corner (Top-Right) */}
          <div style={{ flex: "1", padding: styles.padding, textAlign: styles.textAlign, position: "relative" }}>
            {/* Top-Right Corner */}
            <div style={{ position: "absolute", top: "0px", right: "0px", width: styles.cornerSize }}>
              {/* <Corner /> */}
            </div>

            <h2 style={{ fontWeight: "bold", color: "#5c0e14" }}>Preparation of Construction Documents</h2>
            <h3 style={{ fontSize: "24px", color: "grey" }}>The Details</h3>
            <p>
              Once the finalized design is approved, we will prepare detailed drawings and specifications which the contractor will use to establish actual 
              construction cost and build the project.
            </p>
          </div>

          {/* Image Column */}
          <div style={{ flex: "1", display: "flex", flexDirection: "column", gap: "20px", paddingLeft: styles.imageColumnPadding }}>
            <div style={{ display: "flex", alignItems: "center", gap: "20px" }}>
              <FaProjectDiagram
                style={{ width: "50px", height: "50px", borderRadius: "8px" }}
              />
              <span>End-to-End Project Execution</span>
            </div>
            <div style={{ display: "flex", alignItems: "center", gap: "20px" }}>
              <TiTick
                style={{ width: "50px", height: "50px", borderRadius: "8px" }}
              />
              <span>Budgeting & Quality Control</span>
            </div>
            <div style={{ display: "flex", alignItems: "center", gap: "20px" }}>
              <MdAccessTimeFilled
                style={{ width: "50px", height: "50px", borderRadius: "8px" }}
              />
              <span>Timely Completion & Compliance</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CenteredBoxComponent;
